import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {queries} from '../graphql'

Vue.use(Vuex)

const local_api = false
const lyninx_api_host = local_api ? 'http://localhost:4000' : 'https://api.lyninx.com'
const graphql_api_url = lyninx_api_host + '/graphql'

const state = {
  diaries: [],
  images: [],
  diary: {},
  image: {},
  meta: {},
  api_token: window.localStorage.getItem('lyninx_api_token'),
  loading: true,
  darkmode: (window.localStorage.getItem('darkMode') === 'true'),
}

const mutations = {
  diaries(state, data) {
    state.diaries = []
    state.diaries = data.diaries.sort((a,b) => new Date(a.updated_at) < new Date(b.updated_at))
  },
  images(state, data) {
    state.images = data.images
  },
  diary(state, data) {
    state.diary = data.diary
    state.image = data.diary.image
    state.meta = {
      updated: data.diary.updated_at,
      title: data.diary.title,
      context: data.diary.category
    }
  },
  release(state, data) {
    state.image = data.image
    state.meta = {
      updated: data.updated_at,
      title: data.title,
      context: 'releases'
    }
    state.loading = false
  },
  set_token(state, data) {
    let auth_user = data.auth

    if(auth_user) {
      const token = auth_user.token
      window.localStorage.setItem('lyninx_api_token', token)
      state.api_token = token
    } else {
      window.localStorage.removeItem('lyninx_api_token')
      state.api_token = null
    }
  },
  set_image(state, image) {
    state.image = image
  },
  toggle_dark_mode(state) {
    state.darkmode = !state.darkmode;
    window.localStorage.setItem('darkMode', state.darkmode)
  },
  clear_image(state) {
    state.image = {}
  },
  clear_meta(state) {
    state.meta = {}
  },
}

const actions = {
  async fetchDiaries({ commit }) {
    commit('diaries', await getDiaries())
  },
  async fetchDiary({ commit }, key) {
    commit('diary', await getDiary(key))
  },
  async fetchImage({}, key) {
    return await getImage(key)
  },
  async updateImage({}, image) {
    let file = image.image_file
    delete image.image_file
    return await saveImage(image, file)
  },
  async deleteImage({}, key) {
    return await deleteImage(key)
  },
  async fetchRelease({ commit }, key) {
    commit('release', await getRelease(key))
  },
  async updateDiary({}, diary) {
    return await saveDiary(diary)
  },
  async fetchImages({ commit }) {
    commit('images', await getImages())
  },
  async authenticate({ commit }, password) {
    const response = await authenticate(password)
    commit('set_token', response)
    return response
  },
  setImage({ commit }, image) {
    commit('set_image', image)
  },
  toggleDarkMode({ commit }) {
    commit('toggle_dark_mode')
  },
  clearImage({ commit }) {
    commit('clear_image')
  },
  clearMeta({ commit }) {
    commit('clear_meta')
  },
}

// query graphql api
function query(query, variables = {}) {
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-Type': 'application/json',
      'token': state.api_token
    }
    axios.post(graphql_api_url, {query, variables}, {headers}).then((response) => {
      if(response.data.errors) reject(response.data.errors[0].message)
      resolve(response.data.data)
    }, (err) => { throw err })
  })
}

function authenticate(password) {
  return query(queries.AUTHENTICATE, {password})
}

function getDiaries() {
  return query(queries.DIARIES)
}

function getDiary(key) {
  return query(queries.DIARY, {key})
}

function saveDiary(diary) {
  return query(queries.SAVE_DIARY, {diary: diary})
}

function getImages() {
  return query(queries.IMAGES)
}

function getImage(key) {
  return query(queries.IMAGE, {key})
}

function saveImage(image, image_file) {
  return query(queries.SAVE_IMAGE, {image, image_file})
}

function deleteImage(key) {
  return query(queries.DELETE_IMAGE, {key})
}

function getRelease(key) {
  return new Promise((resolve, reject) => {
    resolve({
      key: 'silver-hearts',
      title: 'Silver Hearts',
      updated_at: new Date('May 1, 2018'),
      image: {
        meta: {
          title: 'Illustration',
          artist: 'Kane',
          source: null
        },
        url: '/static/media/silver_hearts_art.jpg'
      }
    })
  })
}

export default new Vuex.Store({ state, mutations, actions })
